var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.25 12.75H1.75V2.25H7V0.75H1.75C0.9175 0.75 0.25 1.425 0.25 2.25V12.75C0.25 13.575 0.9175 14.25 1.75 14.25H12.25C13.075 14.25 13.75 13.575 13.75 12.75V7.5H12.25V12.75ZM8.5 0.75V2.25H11.1925L3.82 9.6225L4.8775 10.68L12.25 3.3075V6H13.75V0.75H8.5Z","fill":"currentColor"}));
}

SVGIcon.defaultProps = {"width":"14","height":"15","viewBox":"0 0 14 15","fill":"none"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
